// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".row[data-v-92bc6980]:after{content:\"\";display:table;clear:both}.column[data-v-92bc6980]{float:left;width:50%;padding:10px;height:300px}", ""]);
// Exports
module.exports = exports;
